const FakeRequestSender = {
    load: function () {
        let fakeRequestsData = cleverapps.dataLoader.load(DataLoader.TYPES.FAKE_REQUESTS);
        if (!fakeRequestsData) {
            fakeRequestsData = {
                lastLoadTime: 0
            };
        }

        return fakeRequestsData;
    },

    save: function (fakeRequestsData) {
        fakeRequestsData.lastLoadTime = Date.now();
        cleverapps.dataLoader.save(DataLoader.TYPES.FAKE_REQUESTS, fakeRequestsData);
    },

    sendIfNeed: function () {
        if (cleverapps.friends.listInAppIds().length === 0 || ["merge", "merge2"].includes(cleverapps.config.type) || !cleverapps.flags.requestsEnabled) {
            return;
        }

        const friendRequests = levels.friendRequests;
        const fakeRequestsData = FakeRequestSender.load();

        let amountToSend = Math.floor((Date.now() - fakeRequestsData.lastLoadTime) / cleverapps.parseInterval(FakeRequestSender.REQUEST_PERIOD));
        if (amountToSend <= 0) {
            return;
        }

        const fakeRequests = friendRequests.notProcessed.filter((request) => request.isFake());
        if (amountToSend > FakeRequestSender.MAX_REQUESTS - fakeRequests.length) {
            amountToSend = FakeRequestSender.MAX_REQUESTS - fakeRequests.length;
        }

        let sended = false;
        let activeFriends = levels.friendSorter.listActiveFriends();
        PseudoRandom.GET().shuffle(activeFriends);

        if (activeFriends.length > 10) {
            activeFriends = activeFriends.slice(0, 10);
        }

        for (let i = 0; i < activeFriends.length && amountToSend > 0; i++) {
            const friend = activeFriends[i];
            if (friendRequests.existRequestFrom(friend.id)) {
                continue;
            }

            const type = PseudoRandom.GET().mathChoose(this.listFakeRequestsTypes(friendRequests));

            amountToSend--;
            sended = true;

            friendRequests.notProcessed.push(levels.FriendRequest.createFriendRequest({
                id: `__${Math.floor(Math.random() * 1000000000000000)}`,
                from: friend.id,
                type,
                fake: true
            }));
        }

        if (sended) {
            friendRequests.trigger("load");
            FakeRequestSender.save(fakeRequestsData);
            friendRequests.save();
        }
    },

    listFakeRequestsTypes: function (friendRequests) {
        const types = [levels.FriendRequest.TYPE_ASK_HELP_LIVE, levels.FriendRequest.TYPE_ASK_HELP_STAR, levels.FriendRequest.TYPE_ASK_HELP_COINS];
        const availableTypes = friendRequests.listAvailableTypes();

        return types.filter((type) => availableTypes.indexOf(type) !== -1);
    }
};

FakeRequestSender.MAX_REQUESTS = 2;

FakeRequestSender.REQUEST_PERIOD = "12 hours";

if (["crocword", "scramble", "magicwords"].indexOf(cleverapps.config.name) !== -1) {
    FakeRequestSender.REQUEST_PERIOD = "3 hours";
}

if (cleverapps.config.debugMode) {
    FakeRequestSender.REQUEST_PERIOD = "1 minute";
}